import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  Label,
  ModalBody,
  Row,
} from "reactstrap";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import {
  DIVISION_QUERY_KEY,
  VIEW_DIVISION_QUERY_KEY,
  divisionService,
} from "../../../../../Services/divisionService";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Btn } from "../../../../../AbstractElements";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";

interface UpdateDivisionFormProps {
  toggle?: () => void;
  division_id: number;
}

const UpdateDivisionForm: React.FC<UpdateDivisionFormProps> = ({
  toggle,
  division_id,
}) => {
  const queryClient = useQueryClient();
  const user = useAppSelector((state) => state.auth.user);

  const [formData, setFormData] = useState({
    id: division_id,
    company_code: "",
    name: "",
  });

  const { data: divisionData, isLoading: isFetching } = useQuery({
    queryKey: [VIEW_DIVISION_QUERY_KEY, division_id],
    queryFn: () => divisionService.getAllViewDivisionById(division_id),
  });

  useEffect(() => {
    if (divisionData) {
      setFormData({
        id: divisionData.id || division_id,
        company_code: divisionData.company_code || "",
        name: divisionData.name || "",
      });
    }
  }, [divisionData]);

  const updateDivisionMutation = useMutation({
    mutationFn: (data: typeof formData) =>
      divisionService.updateDivision(division_id, data),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: VIEW_DIVISION_QUERY_KEY });
      toast.success(result.message);
      if (toggle) toggle();
    },
    onError: (error: any) => {
      const responseData = error.response?.data;
      if (responseData?.message) {
        toast.error(responseData.message);
      } else {
        toast.error("Failed to update division.");
      }
    },
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateDivisionMutation.mutate(formData);
  };

  return (
    <ModalBody>
      <Form className="needs-validation" onSubmit={handleSubmit}>
        <Row className="g-3">
          <Col md="12">
            <Label>
              Name<b className="text-danger">*</b>
            </Label>
            <Input
              id="name"
              name="name"
              type="text"
              placeholder="Loading..."
              maxLength={150}
              minLength={3}
              required
              disabled={isFetching}
              value={formData.name}
              onChange={handleInputChange}
            />
          </Col>

          <Col md="12">
            <Btn
              color="primary"
              className="w-100"
              type="submit"
              disabled={updateDivisionMutation.isPending || isFetching}
            >
              {updateDivisionMutation.isPending
                ? "Updating Division..."
                : "Update"}
            </Btn>
          </Col>
        </Row>
      </Form>
    </ModalBody>
  );
};

export default UpdateDivisionForm;
